export const CARD_WIDTH = 68;
export const CARD_ASPECT_RATIO = 9 / 16;
export const CARD_GAP = 12;
export const CARD_PAGE_SIZE = 10;
